import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import TYPE from "../../../../../../../constant/TYPE";
import Grammar from "./grammar/Grammar";

const Question = () => {

  const deviceInfo = useSelector( state => state.deviceInfo );

  return (
    <div className={ clsx( 'learning_body', deviceInfo.type && TYPE.DEVICE.PC !== deviceInfo.type && 'with_key' ) }>
      <Grammar />
    </div>
  );

};

export default Question;
